import React from "react";

export function SectionHeader({ eyebrow, title, description, align = "left", accent }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      {eyebrow && <div className="eyebrow reveal">{eyebrow}</div>}
      <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-3 leading-[1.05] tracking-tight reveal reveal-1 text-balance">
        {title} {accent && <span className="italic text-primary">{accent}</span>}
      </h2>
      {description && (
        <p className="mt-6 text-base md:text-lg text-muted-foreground leading-relaxed reveal reveal-2 text-pretty">
          {description}
        </p>
      )}
    </div>
  );
}

export function PageHeader({ eyebrow, title, description, image, height = "min-h-[60vh]" }) {
  return (
    <section className={`relative ${height} w-full overflow-hidden flex items-end`}>
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/20" />
        </>
      )}
      <div className="relative container-x pb-14 md:pb-20 pt-32">
        <div className="max-w-4xl">
          {eyebrow && <div className="eyebrow reveal">{eyebrow}</div>}
          <h1 className="font-display text-5xl md:text-7xl lg:text-[5.5rem] leading-[0.98] tracking-tight mt-3 reveal reveal-1 text-balance">
            {title}
          </h1>
          {description && (
            <p className="mt-6 text-base md:text-lg text-muted-foreground max-w-2xl reveal reveal-2 text-pretty">
              {description}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
